import type { ReactNode } from 'react';

export const symbol_hevc: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-384v-192q0-10 7-17t17-7q10 0 17 7t7 17v63h55v-63q0-10 7-17t17-7q10 0 17 7t7 17v192q0 10-7 17t-17 7q-10 0-17-7t-7-17v-81h-55v81q0 10-7 17t-17 7q-10 0-17-7t-7-17Zm204 1v-195q0-9 7-15.5t16-6.5h81q10 0 17 7t7 17q0 10-7 17t-17 7h-56v39h56q10 0 17 7t7 17q0 10-7 17t-17 7h-56v57h56q10 0 17 7t7 17q0 10-7 17t-17 7h-81q-9 0-16-7t-7-16Zm201-9-34-180q-2-11 5.5-19.5T515-600q9 0 15.5 6t8.5 14l32 171 31-171q2-8 8.5-14t15.5-6q11 0 18.5 9t5.5 20l-34 179q-2 14-13 23t-25 9h-15q-14 0-25-9t-13-23Zm198 32q-15 0-24.5-9.5T689-394v-172q0-15 9.5-24.5T723-600h83q15 0 24.5 9.5T840-566v18q0 10-7 17t-17 7q-10 0-17-7t-7-17v-4h-55v144h55v-1q0-10 7-17t17-7q10 0 17 7t7 17v15q0 15-9.5 24.5T806-360h-83Z"
		/>
	</svg>
);
